module.exports = __webpack_public_path__ + "bd1d2adfc3d5018eb21b082c6391e0ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/diamond_pattern_on_pink_right.png
// module id = 849
// module chunks = 0